import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import TopNav from "../components/TopNav";
import { setIntent, clearIntake } from "../lib/intakeStore";
import { PROGRAMS_FOR_PICKER } from "../lib/intakeSteps";
import { useLang } from "../lib/i18n";
import { getIntakeContent } from "../lib/intakeContent";

/** Wipe every shred of an old anonymous intake session.
 *  Called on every fresh /intake/start mount so a stale token from a previous
 *  build (cookie-based) can never bleed into a new intake. */
function purgeStaleIntakeSession() {
  try {
    localStorage.removeItem("aabb_intake_session");
    // Best-effort clear of the legacy server-set cookie (httponly cookies can't
    // be deleted from JS, but we set a same-name overwrite with past expiry to
    // shadow it if the browser ever falls back to cookie reads).
    document.cookie = "aabb_intake_session=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
    document.cookie = "aabb_intake_session=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + window.location.hostname;
  } catch { /* noop */ }
}

export default function IntakeStart() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [expiredBanner] = useState(params.get("expired") === "1");
  const { lang } = useLang();
  const ic = getIntakeContent(lang);

  useEffect(() => {
    purgeStaleIntakeSession();

    // If product parameter is provided, skip program picker and go directly to intake
    const productParam = params.get("product");
    if (productParam) {
      clearIntake();
      setIntent({ kind: "product", slug: productParam });
      nav(`/intake?product=${productParam}`);
    }
  }, [params, nav]);

  const pick = (slug) => {
    purgeStaleIntakeSession();   // belt-and-suspenders
    clearIntake();
    setIntent({ kind: "program", slug });
    nav(`/intake?program=${slug}`);
  };

  return (
    <>
      <TopNav minimal />
      <div className="aa-shell">
        {expiredBanner && (
          <div className="aa-error" data-testid="intake-expired-banner" style={{marginBottom:18}}>
            {ic.start.expiredBanner}
          </div>
        )}
        <div className="aa-eyebrow">{ic.start.eyebrow}</div>
        <h1 className="aa-h1">{ic.start.title}</h1>
        <p className="aa-sub">{ic.start.subtitle}</p>
        <div className="aa-options">
          {PROGRAMS_FOR_PICKER.map(p => {
            const prog = ic.programs[p.slug];
            return (
              <button key={p.slug} className="aa-card" onClick={()=>pick(p.slug)} data-testid={`pick-${p.slug}`}>
                {prog?.badge && <span className="aa-badge">⭐ {prog.badge}</span>}
                <div className="aa-card-title">{prog?.name || p.name}</div>
                <div className="aa-card-sub">{prog?.desc || p.desc}</div>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}
